import React, { Fragment, useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { Label } from 'reactstrap';
import Select from "react-select";
import axios from 'axios';

// Pixacom imports
import { newToast } from '../DSA/Toast';

const PixSelect = forwardRef((props, ref) => {

  // Props attributes
  const {
    id, name, placeholder,
    className = null, style = {},
    menuPlacement = 'bottom',
    required = false,
    disabled = false,
    clearable = false,
    emptyValue,
    apiLink, data,
    editID = null,
    withoutIds = [],
    keyParameter = 'id'
  } = props;

  // Props functions
  const {
    onChange = () => {},
    labelFormat
  } = props;

  // Constants
  const [config] = useState({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

  // States
  const [selectedValue, setSelectedValue] = useState(undefined);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Mount
  useEffect(() => {
    if (data) {
      loadLocalData();
    }
    else {
      loadData();
    }
    setIsLoading(false);
  }, []);

  // Update
  useEffect(() => {
    if (data) {
      if (options.length === 0)
        loadLocalData();
      else if (data.length === 0 && options.length > 0)
        setOptions([]);
    }
    if (editID !== null && (selectedValue === null || selectedValue === undefined)) {
      setSelectedValue(editID)
    }
  }, [data])

  useEffect(() => {
    if (apiLink)
      loadData();
  }, [apiLink])

  useEffect(() => {
    setSelectedValue(editID)
  }, [editID])

  useEffect(() => {
    if (emptyValue) {
      let isExist = options.find(itm => itm.value === null);

      if (!isExist)
        setOptions(prevState => [{ value: null, label: emptyValue, object: null }, ...prevState])
    }
  }, [emptyValue]);

  const loadLocalData = () => {
    if (labelFormat) {
      let rowData = [];

      data.forEach(item => {
        let label = labelFormat(item);

        rowData.push({ value: item[keyParameter], label: label });
      });
      setOptions(rowData);
    }
    else
      setOptions(data);
  }

  useImperativeHandle(ref, () => ({
    reload: reloadData
  }));

  const reloadData = async () => {
    if (apiLink)
      await loadData();
  }

  const loadData = async () => {
    try {
      let response = await axios.get(apiLink, config);

      if (response.status >= 200 && response.status <= 299) {
        let data = response.data;

        if (data) {
          let rowData = [];

          if (emptyValue) {
            rowData.push({ value: null, label: emptyValue, object: null });
          }

          data.forEach(item => {
            let label = '';

            if (labelFormat)
              label = labelFormat(item);
            else
              label = item.name;

            rowData.push({ value: item[keyParameter], label: label, object: item });
          });

          setOptions(rowData);
          setIsLoading(false);
        }
      }
      else console.error('Bad response status: ' + response.status + ' from ' + apiLink);
    }
    catch (err) { newToast.error('Data loading error', err.message) }
  }

  const handleChange = event => {
    onChange(event?.value, event?.object);
    setSelectedValue(event?.value);
  }

  return (
    <Select
      id={ id }
      name={ name }
      menuPlacement={ menuPlacement }
      isDisabled={ disabled }
      isLoading={ isLoading }
      className={ className }
      isClearable={ clearable }
      styles={{...style, menu: provided => ({ ...provided, zIndex: 9999, }), }}
      placeholder={ placeholder }
      onChange={ handleChange }
      options={ options.filter(item => !withoutIds.includes(item.value)) }
      value={
        selectedValue !== null && selectedValue !== undefined
          ? options.filter(item => item.value == selectedValue)
          : emptyValue
            ? { value: null, label: emptyValue}
            : null
      }
    />
  );
});

export default PixSelect;
